module.exports = __webpack_public_path__ + "pcid/img/may14.63ca0e4b.png";